<template>
<div class="order-container">
<dv-border-box-12>
  <div class="order-list">
    <template v-if="orderList.length != 0">
      <div class="order-item" v-for="(item, index) in orderList" :key="'column2Order' + index">
        <div>订单{{item.orderNo}}</div>
        <div>{{item.qname}}-{{item.zname}}</div>
        <div>{{item.price}}</div>
        <div>{{item.creatDete}}</div>
        <div v-if="index < 2" class="line"></div>
      </div>
    </template>
    <template v-else>
      <div class="order-item" v-for="item in 3" :key="'loading' + item">
        <Loading></Loading>
        <div v-if="item <= 2" class="line"></div>
      </div>
    </template>
  </div>
</dv-border-box-12>
</div>
</template>

<script>
import Loading from '../../common/Loding.vue'
export default {
  props: {
    orderList: {
      type: Array,
      default: () => {
        return [
          // {
          //   orderNo: 1234567891234,
          //   qname: '遂宁市',
          //   zname: '中山市',
          //   price: 6235.2,
          //   creatDete: '2022/1/4 15:26'
          // },
          // {
          //   orderNo: 1234567891234,
          //   qname: '遂宁市',
          //   zname: '贵阳市',
          //   price: 6235.2,
          //   creatDete: '2022/1/4 15:26'
          // },
          // {
          //   orderNo: 1234567891234,
          //   qname: '遂宁市',
          //   zname: '大连市',
          //   price: 6235.2,
          //   creatDete: '2022/1/4 15:26'
          // }
        ]
      }
    }
  },

  components: {
    Loading
  }
}
</script>

<style lang="less" scoped>
.order-container {
  width: 574px;
  height: 126px;
  .order-list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100%;
    color: #fff;
  }
  .order-item {
    width: 191px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    div:nth-child(1),
    div:nth-child(4) {
      color: #687183;
      font-size: 11px;
      font-family: 'SourceHanSansCN-Normal';
    }
    div:nth-child(2),
    div:nth-child(3) {
      font-size: 20px;
    }
    .line {
      z-index: 999;
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 80px;
      background: linear-gradient(
        0deg, 
        rgba(255, 255, 255, 0) 0%, 
        rgba(0, 117, 169, 0.97) 51%, 
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
}
</style>
